/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

type Props = {
    title: string
    link: string | undefined
}

const LinkWidget: React.FC<Props> = ({ title, link }) => {
    // helper to safely base64-encode unicode strings in browsers
    const encodeToBase64 = (str: string) => {
        try {
            // encodeURIComponent -> percent-encoded UTF-8, then convert to raw bytes for btoa
            return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_match, p1) => String.fromCharCode(parseInt(p1, 16))));
        } catch (e) {
            // fallback to plain btoa (may throw for non-latin1 input)
            try { return btoa(str); } catch { return ""; }
        }
    }

    if (link !== undefined && link !== "") {
        let href = link

        // If the widget title is 'Ecard' then send the link as a base64 encoded
        // value in the `ecard` query param to the webhook URL.
        // if (title === 'Ecard') {
        //     const encoded = encodeURIComponent(encodeToBase64(link))
        //     href = `https://etl.futurisk.in/webhook/20141280-a4f2-425d-9fee-f14419b219e1?ecard=${encoded}`
        // }

        return (
            <a className={` hoverable`} href={href} target='_blank' rel="noopener noreferrer">
                <div className='border bg-light-primary border-primary border-dashed rounded 
                                                             py-3 px-4 me-6 mb-3 border-hover-success 
                                                            bg-hover-primary text-hover-white'>
                    <div className='d-flex align-items-center'>
                        <div className='fs-6 fw-bolder'> {title} </div>
                    </div>
                </div>
            </a>
        )
    }
    else {
        return (
            <div className='border bg-light-primary border-primary border-dashed rounded 
                                     py-3 px-4 me-6 mb-3'>
                <div className='d-flex align-items-center'>
                    <div className='fs-6 fw-bolder'> {title} </div>
                </div>
            </div>
        )
    }
}

export { LinkWidget }
